<template>
  <div class="tw-min-h-[calc(100vh-146px)] tw-bg-bgPage">
    <BaseTopLine> </BaseTopLine>

    <vue-tabs
      v-model="activateTab"
      @tab-change="handleTabChange"
      class="vue-tabs-type-1"
    >
      <v-tab :title="dataLang['reg_employee_1']" data-name="employees">
        <div class="tw-px-[26px] tw-mt-[15px]">
          <div class="tw-mb-[15px] tw-flex tw-items-center tw-gap-[10px]">
            <button
              class="tw-app-btn-primary"
              @click="
                $modal.show('employeeModal', { data: {}, type: 'create' })
              "
            >
              <img
                :src="require(`@/assets/icons/addwhite.svg`)"
                width="13.5"
                height="13.5"
                class="tw-my-[-5px]"
              />
              {{ dataLang["registry_ads_text1"] }}
            </button>
            <button
              class="tw-app-btn-primary-outline"
              @click="
                activeSelectRowsMultiple.length
                  ? $modal.show('deleteEmployeeModal')
                  : $toast.error('Выберите хотя бы одного сотрудника')
              "
            >
              <img
                :src="require(`@/assets/icons/minus-dark.svg`)"
                width="13.5"
                height="13.5"
                class="tw-my-[-5px]"
              />
              {{ dataLang["registry_ads_text2"] }}
            </button>
          </div>

          <div class="tw-flex tw-justify-between">
            <div class="tw-flex">
              <button @click="loadData()" class="tw-app-btn-primary-outline">
                {{ dataLang["register_btn_filter_on"] }}
              </button>
              <button
                @click="resetFilter()"
                class="tw-app-btn-light !tw-text-[#0056AF]"
              >
                Сбросить
              </button>
            </div>
            <TwBasePagination
              :page-count="numPages"
              :pagination-params="{
                ...paginationFinesStateParams,
                limit: limitPaginationValue,
              }"
              :showLimitInput="true"
              @updateLimitValue="updateLimitValue"
              :page-range="10"
              :margin-pages="0"
              :click-handler="loadData"
            >
            </TwBasePagination>
          </div>

          <div class="tw-relative tw-mt-[15px]" style="min-height: 400px">
            <BaseLoader v-if="localLoading"></BaseLoader>
            <ve-table
              class="rest-style-table fixed-header"
              style="width: 100%"
              :columns="columns"
              :table-data="dataTable"
              :border-x="true"
              :border-y="true"
              row-key-field-name="employees__id"
              ref="mainTable"
              :eventCustomOption="eventCustomOptionMain"
              v-if="!localLoading"
              :checkbox-option="{
                selectedRowChange: selectedRowChange,
                selectedAllChange: selectedAllChange,
                hideSelectAll: false,
              }"
              :clickHighlight="false"
              :cell-style-option="cellStyleOption"
              :rowStyleOption="{
                hoverHighlight: true,
              }"
              :cellSelectionOption="{ enable: false }"
            >
            </ve-table>
          </div>
        </div>
      </v-tab>

      <v-tab :title="dataLang['reg_employee_2']" data-name="jobtitle">
        <div class="tw-px-[26px] tw-mt-[15px]">
          <div class="tw-mb-[15px] tw-flex tw-items-center tw-gap-[10px]">
            <button
              class="tw-app-btn-primary"
              @click="$modal.show('createJobtitleModal')"
            >
              <img
                :src="require(`@/assets/icons/addwhite.svg`)"
                width="13.5"
                height="13.5"
                class="tw-my-[-5px]"
              />
              {{ dataLang["registry_ads_text1"] }}
            </button>
            <button class="tw-app-btn-primary-outline" @click="deleteJobtitle">
              <img
                :src="require(`@/assets/icons/minus-dark.svg`)"
                width="13.5"
                height="13.5"
                class="tw-my-[-5px]"
              />
              {{ dataLang["registry_ads_text2"] }}
            </button>
          </div>
          <div class="tw-relative tw-mt-[15px]" style="min-height: 400px">
            <BaseLoader v-if="localLoading"></BaseLoader>
            <ve-table
              class="rest-style-table fixed-header"
              style="width: 100%"
              :columns="columnsSecond"
              :table-data="dataTableSecond"
              :border-x="true"
              :border-y="true"
              row-key-field-name="employee_jobtitles__id"
              ref="mainTable"
              :eventCustomOption="eventCustomOptionSecond"
              v-if="!localLoading"
              :checkbox-option="{
                selectedRowChange: selectedRowChange,
                selectedAllChange: selectedAllChange,
                hideSelectAll: false,
              }"
              :clickHighlight="false"
              :cell-style-option="cellStyleOption"
              :rowStyleOption="{
                hoverHighlight: true,
              }"
              :cellSelectionOption="{ enable: false }"
            >
            </ve-table>
          </div>
        </div>
        <JobtitlesModal :activeTab="this.dataLang['reg_employee_4']" />
      </v-tab>
    </vue-tabs>

    <EmployeeModal />

    <BaseModal
      name="deleteEmployeeModal"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      height="auto"
      classes="tw-app-modal"
    >
      <div class="tw-app-modal__container">
        <BaseLoader v-if="localLoading" class="tw-rounded-[25px]"></BaseLoader>
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('deleteEmployeeModal')"
        ></button>

        <div>
          <div class="tw-app-modal__title">
            {{ dataLang["reg_employee_28"] }}
          </div>

          <div class="tw-flex tw-gap-[10px] tw-mt-[15px] tw-justify-center">
            <button
              @click="$modal.hide('deleteEmployeeModal')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              {{ dataLang["reg_employee_18"] }}
            </button>
            <button
              @click="onDeleteEmployee"
              class="tw-app-btn-primary tw-app-btn-primary-lg"
            >
              {{ dataLang["reestr_fines_super_text27"] }}
            </button>
          </div>
        </div>
      </div>
    </BaseModal>

    <BaseModal
      name="errorDeleteEmployeeModal"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      @before-close="$modal.hide('deleteEmployeeModal')"
      height="auto"
      classes="tw-app-modal"
    >
      <div class="tw-app-modal__container">
        <BaseLoader v-if="localLoading" class="tw-rounded-[25px]"></BaseLoader>
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('errorDeleteEmployeeModal')"
        ></button>
        <div>
          <div class="tw-app-modal__title">{{ errorResponseMessage }}</div>

          <div class="tw-flex tw-gap-[10px] tw-mt-[15px] tw-justify-center">
            <button
              @click="$modal.hide('errorDeleteEmployeeModal')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              {{ dataLang["reg_employee_18"] }}
            </button>
          </div>
        </div>
      </div>
    </BaseModal>

    <BaseModal
      name="createJobtitleModal"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      height="auto"
      classes="tw-app-modal"
    >
      <div class="tw-app-modal__container">
        <BaseLoader v-if="localLoading" class="tw-rounded-[25px]"></BaseLoader>
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('createJobtitleModal')"
        ></button>

        <div>
          <div class="tw-app-modal__title">Создать должность</div>

          <div class="tw-mb-[15px]">
            <div class="tw-app-input-type-3-label">
              {{ dataLang["reg_employee_20"] }}
            </div>
            <BaseInputNew
              inputClass="tw-app-input-type-3"
              @input="updateValue"
              inputName="employee_jobtitles__name"
            />
          </div>

          <div class="tw-flex tw-gap-[10px] tw-mt-[15px] tw-justify-center">
            <button
              @click="$modal.hide('createJobtitleModal')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              {{ dataLang["reg_employee_18"] }}
            </button>
            <button
              @click="createJobtitle"
              class="tw-app-btn-primary tw-app-btn-primary-lg"
            >
              {{ dataLang["reg_employee_19"] }}
            </button>
          </div>
        </div>
      </div>
    </BaseModal>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import { VeTable } from "vue-easytable";
import GeneralService from "@/api/GeneralService";
import httpInstance from "@/http-common";
import { VueTabs, VTab } from "vue-nav-tabs/dist/vue-tabs.js";
import EmployeeModal from "@/views/employees-modal/EmployeeModal.vue";
import JobtitlesModal from "@/views/employees-modal/JobtitlesModal.vue";
import EventBus from "@/event-bus.js";
export default {
  components: {
    VeTable,
    VueTabs,
    VTab,
    EmployeeModal,
    JobtitlesModal,
  },

  data() {
    return {
      limitPaginationValue: 50,
      localLoading: true,
      dataTable: [],
      dataTableSecond: [],
      activeSelectRowsMultiple: [],
      filter: [],
      activateTab: "",
      updatedValues: {},
      computedAllPage: 1,
      currentPage: 1,
      errorResponseMessage: "",

      filterTimes: {
        contractsCreateStart: "",
        contractsCreateEnd: "",
        startsRateTime: "",
        endRateTime: "",
        startsRateFinishTime: "",
        endRateFinishTime: "",
      },
      activePagePagination: {},
      newValueCustomModal: "",
      currentId: null,
      localLoadingModal: false,
      pincode: "",
      dataForModal: {},

      selectsData: {
        jobtitles: [],
      },
      selectsFilter: {
        jobtitles: [],
      },
      eventCustomOptionMain: {
        bodyRowEvents: ({ row, rowIndex }) => {
          return {
            dblclick: (event) => {
              this.$modal.show("employeeModal", { data: row, type: "edit" });
            },
          };
        },
      },
      eventCustomOptionSecond: {
        bodyRowEvents: ({ row, rowIndex }) => {
          return {
            dblclick: (event) => {
              this.$modal.show("jobtitlesModal", row);
            },
          };
        },
      },
      cellStyleOption: {
        bodyCellClass: ({ row, column, rowIndex }) => {
          if (
            column.field === "employees__is_login_blocked" &&
            row.employee_jobtitles__is_locked
          ) {
            return "cell-status-red";
          }
        },
      },
    };
  },
  methods: {
    deleteJobtitle() {
      if (this.activeSelectRowsMultiple.length) {
        GeneralService.delete(`/jobtitles/${this.activeSelectRowsMultiple}`)
          .then((data) => {
            // this.$modal.hide('createJobtitleModal')

            this.$toast.success(data.data.message);
          })
          .catch((e) => {
            this.errorResponseMessage = e.response.data.message;
            this.$modal.show("errorDeleteEmployeeModal");
          })
          .finally(() => {
            this.loadData();
          });
      } else {
        this.$toast.error("Выберите поле", { duration: 5000 });
      }
    },
    createJobtitle() {
      this.localLoading = true;
      GeneralService.editOrCreate(`/jobtitles`, {
        ...this.updatedValues,
      })
        .then((data) => {
          this.$modal.hide("createJobtitleModal");
          this.$toast.success(data.data.message);
        })
        .catch((e) => {
          this.errorResponseMessage = e.response.data.message;
          this.$modal.hide("createJobtitleModal");
          this.$modal.show("errorDeleteEmployeeModal");
        })
        .finally(() => {
          this.loadData();
        });
    },
    onDeleteEmployee() {
      GeneralService.delete(`/employees/${this.activeSelectRowsMultiple}`)
        .then((data) => {
          this.$modal.hide("deleteEmployeeModal");
        })
        .catch((e) => {
          this.errorResponseMessage = e.response.data.message;
          this.$modal.show("errorDeleteEmployeeModal");
        })
        .finally(() => {
          this.loadData();
        });
    },
    selectedRowChange({ row, isSelected, selectedRowKeys }) {
      this.activeSelectRowsMultiple = selectedRowKeys;
    },
    selectedAllChange({ row, isSelected, selectedRowKeys }) {
      this.activeSelectRowsMultiple = selectedRowKeys;
    },
    updateValue(data) {
      this.updatedValues[data.name] = data.value;
    },
    handleTabChange(tabIndex, newTab, oldTab) {
      console.log(
        "TABS CHANGE CONSOLE",
        this.activeTab,
        tabIndex,
        newTab,
        oldTab
      );
      this.activeSelectRowsMultiple = [];
      this.resetFilter();
    },
    computedTranslate(values, tranaslate) {
      let keys = Object.keys(values);
      let tranaslateLocal = tranaslate;
      keys.forEach((keyName) => {
        tranaslateLocal = tranaslateLocal.replace(
          `\\${keyName}\\`,
          values[keyName]
        );
      });
      return tranaslateLocal;
    },
    resetFilter() {
      this.$refs.mainTable.$el
        .querySelectorAll("input.base-input--new")
        .forEach((elem, index) => {
          elem.value = "";
        });
      this.filter = [];
      this.loadData();
    },
    deleteAcceptRow() {
      GeneralService.delete(`/trackers/` + this.activeSelectRowsMultiple)
        .then((data) => {
          this.loadData();
        })
        .catch((e) => {});
    },
    updateLimitValue(data) {
      this.limitPaginationValue = data;
      this.loadData();
    },
    loadData(page = 1) {
      this.localLoading = true;
      Promise.all([
        GeneralService.get(`/jobtitles`)
          .then((data) => {
            this.selectsData.jobtitles = data.data.data;
          })
          .catch((e) => {
            this.$toast.error(
              "Неизвестная ошибка при загрузке источников рекламы"
            );
          }),
      ]).then(() => {
        if (this.activateTab == this.dataLang["reg_employee_1"]) {
          GeneralService.get(`/employees/table/main`, {
            params: {
              ...this.paginationFinesStateParams,
              page: page,
              limit: this.limitPaginationValue,
              ...(this.filter.length && {
                where: JSON.stringify([...this.filter]),
              }),
            },
          })
            .then((data) => {
              this.dataTable = data.data.data.rows;
              this.getFinesAll(data.data.data);
              this.localLoading = false;
            })
            .catch((e) => {
              this.$toast.error("Неизвестная ошибка при загрузке таблицы", {
                duration: 5000,
              });
            });
        } else {
          GeneralService.get(`/jobtitles`)
            .then((data) => {
              this.dataTableSecond = data.data.data.reverse();
              this.localLoading = false;
            })
            .catch((e) => {
              this.$toast.error("Неизвестная ошибка при загрузке таблицы", {
                duration: 5000,
              });
            });
        }
      });
    },
    fillFilter(data) {
      let newValueFilter =
        data.type == "like" ? `;percent;${data.value};percent;` : data.value;
      if (!this.filter.find((x) => x.field == data.name)) {
        this.filter.push({
          field: data.name,
          value: newValueFilter,
          ...(data.type == "like" && { operator: "like" }),
          ...(data.operator && { operator: data.operator }),
          ...(data.mod && { mod: data.mod }),
        });
      } else {
        this.filter[this.filter.findIndex((x) => x.field == data.name)].value =
          newValueFilter;
      }
    },
    prepareLabelsForDefaultSelects(data, keyDataFromFetch, toTranslate) {
      for (const key in data) {
        data[key].forEach((element) => {
          element["label"] = element[Object.keys(element).pop()];
          element["key"] = key;
          element["value"] = Object.keys(element)[0];
          element["selectName"] = keyDataFromFetch;
        });
      }
      return data;
    },
    ...mapActions("finesPagination", ["getFinesAll"]),
  },
  mounted() {
    EventBus.$on("updateContentDataJobtitles", (data) => {
      if (data) {
        this.$modal.hide("jobtitlesModal");
      }
      this.$modal.hide("employeeModal");
      if (this.currentOpenedId) {
        this.loadData(this.currentOpenedId);
      } else {
        this.loadData();
      }
    });
  },
  created() {
    this.loadData();
  },
  beforeDestroy() {
    EventBus.$off("updateContentDataJobtitles");
  },
  computed: {
    ...mapState("translationModule", ["dataLang"]),
    ...mapState("userSettingModule", ["userSetting"]),
    ...mapState("finesPagination", ["paginationFinesStateParams"]),
    ...mapGetters("finesPagination", ["numPages"]),

    columnsSecond() {
      return [
        {
          field: "",
          key: "a6",
          type: "checkbox",
          title: "",
          width: "2%",
          align: "center",
        },
        {
          field: "employee_jobtitles__name",
          key: "16361",
          title: this.dataLang["reg_employee_4"],
          align: "center",
          width: "30%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div class={"h-100"}>
                <div class={"text-center"}>{column.title}</div>
              </div>
            );
          },
        },
      ];
    },

    columns() {
      return [
        {
          field: "",
          key: "a6",
          type: "checkbox",
          title: "",
          width: "2%",
          align: "center",
        },
        {
          field: "employees__name",
          key: "16364",
          title: this.dataLang["reg_employee_3"],
          align: "center",
          width: "30%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div class={"h-100"}>
                <div class={"text-center"}>{column.title}</div>
                <BaseInputNew
                  inputClass="tw-app-input-dark tw-app-input-dark-small"
                  placeholder=""
                  disabled={false}
                  onInput={this.fillFilter}
                  additionalParams={{ type: "like" }}
                  inputName={"employees__name"}
                  value={""}
                  nameSign={""}
                />
              </div>
            );
          },
        },
        {
          field: "employee_jobtitles__name",
          key: "16361",
          title: this.dataLang["reg_employee_4"],
          align: "center",
          width: "30%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div class={"h-100"}>
                <div class={"text-center"}>{column.title}</div>
                <BaseInputNew
                  inputClass="tw-app-input-dark tw-app-input-dark-small"
                  placeholder=""
                  disabled={false}
                  onInput={this.fillFilter}
                  additionalParams={{ type: "like" }}
                  inputName={"employee_jobtitles__name"}
                  value={""}
                  nameSign={""}
                />
              </div>
            );
          },
        },
        {
          field: "employees__phone",
          key: "16362",
          title: this.dataLang["reg_employee_5"],
          align: "center",
          width: "8%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div class={"h-100"}>
                <div class={"text-center"}>{column.title}</div>
              </div>
            );
          },
        },
        {
          field: "employees__email",
          key: "16336",
          title: this.dataLang["reg_employee_6"],
          align: "center",
          width: "7%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div class={"h-100"}>
                <div class={"text-center"}>{column.title}</div>
              </div>
            );
          },
        },
        {
          field: "employees__last_login_at",
          key: "14636",
          title: this.dataLang["reg_employee_7"],
          align: "center",
          width: "7%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div class={"h-100"}>
                <div class={"text-center"}>{column.title}</div>
              </div>
            );
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                {row.employees__last_login_at
                  ? this.$time(row.employees__last_login_at)
                      .utc(true)
                      .utcOffset(Number(this.userSetting.company__utc))
                      .format(
                        `${this.userSetting.company__tempalte_date} HH:mm`
                      )
                  : ""}
              </span>
            );
          },
        },
        {
          field: "employee_jobtitles__is_locked",
          key: "15636",
          title: this.dataLang["reg_employee_8"],
          align: "center",
          width: "7%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div class={"h-100"}>
                <div class={"text-center"}>{column.title}</div>
              </div>
            );
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                {row.employees__is_login_blocked
                  ? this.dataLang["yes"]
                  : this.dataLang["no"]}
              </span>
            );
          },
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.top-line-custom {
  position: absolute;
  display: flex;
  justify-content: space-between;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 14px;
  color: white;
  width: 65%;
}
</style>
